module.exports = __webpack_public_path__ + "media/beep-long.6053d9a8.wav";